import initFormAnimation from "../../../template/js/template";

export default class PartnershipFormHandler{

    constructor(loadingHandler, toastHandler, errorHandler, modal) {
        this.form = $("#partnerWithScoutersForm");
        this.loadingHandler = loadingHandler;
        this.crudApi = CRUD_API;
        this.toastHandler = toastHandler;
        this.errorHandler = errorHandler;
        this.partnershipModal = modal;
    }

    init(){
        const self = this;
        initFormAnimation(self.form);
        self.sendButton = $("#partnershipSendButton");
        self.leadName = $("#partnershipLeadName");
        self.leadEmail = $("#partnershipLeadEmail");
        self.leadCompany = $("#partnershipLeadCompany");
        self.leadMessage = $("#partnershipLeadMessage");
        self.sendButton.on("click", async function (e){
            e.preventDefault();
            const inputs = document.querySelectorAll('.partnership-modal form .need-validation');
            inputs.forEach(input => {
                input.classList.remove('is-invalid');
                input.classList.remove('is-valid');
            });
            self.form[0].classList.add('was-validated');
            if (!self.form[0].checkValidity()) {
                return;
            }
            try {
                self.loadingHandler.show();
                await self.executeRequest();
                let message = "Request sent successfully.";
                self.toastHandler.showToast(message);
                self.partnershipModal.hide();
            }
            catch (e){
                console.error(e);
                self.loadingHandler.hide();
                self.errorHandler.handleErrorNotifyAdminAndUser("There was an error processing the request.", new Error(JSON.stringify(e)));
            }
            self.loadingHandler.hide();
        });
    }

    executeRequest(){
        const self = this;
        const requestBody = {
            name: self.leadName.val(),
            company: self.leadCompany.val(),
            email: self.leadEmail.val(),
            message: self.leadMessage.val()
        }
        return $.ajax({
            url: self.crudApi + "/leads/create",
            type: 'post',
            dataType: 'json',
            contentType: "application/json",
            data: JSON.stringify(requestBody)
        });
    }

}